import { IQueryOptions, IExecutionOptions } from '../models/query';
import { Query } from './Query';
import { TranslationHelper } from '../helpers/TranslationHelper';
import { IQueryOptionsContentBase } from '../models/query/options/IQueryOptionsContentBase';
import { BaseEntityQuery } from './BaseEntityQuery';
import { IContentItem } from '../models/api/dictionary';

export const MAX_CALL_STACK_LEVEL: number = 50;

export abstract class BaseContentQuery<TChildOptions extends IQueryOptionsContentBase> extends BaseEntityQuery<TChildOptions> {
	constructor(queryOptions: IQueryOptions, translationHelper?: TranslationHelper) {
		super(queryOptions, translationHelper);
	}

	getRawValueForContentElement(executionOptions: IExecutionOptions, contentItemKey: string) {
		const { queryOptionsType } = this.queryOptions;
		const { key, entityType } = this.options;
		if (entityType) {
			const entity = this.getEntity(executionOptions);
			if (entity) {
				const contentObject = entity[queryOptionsType] as { [key: string]: IContentItem[] };
				if (contentObject) {
					const contentTypeCollection = contentObject[key];
					if (contentTypeCollection) {
						const { culture, fallbackCulture } = executionOptions;
						let contentItem = contentTypeCollection.find(item => item.culture === culture);
						if (!contentItem) {
							contentItem = contentTypeCollection.find(item => item.culture === fallbackCulture);
						}
						return (contentItem && contentItem[contentItemKey]) as any;
					}
				}
			}
		}
		else {
			const keysByContentItemKey = {
				'commentary': {
					globalContextKey: 'globalCommentaries',
					contentParentKey: 'commentaryType',
					contentValuesKey: 'commentaries',
				},
				'disclaimer': {
					globalContextKey: 'globalDisclaimers',
					contentParentKey: 'disclaimerType',
					contentValuesKey: 'disclaimers',
				},
			};
			const keysForContentItemKey = keysByContentItemKey[contentItemKey];
			if (keysForContentItemKey) {
				const { globalContextKey, contentParentKey, contentValuesKey } = keysForContentItemKey;
				const context = Query.getContext(executionOptions, this.queryOptions);
				if (context) {
					const collection = context[globalContextKey] as any[];
					if (collection && Array.isArray(collection)) {
						const contentParent = collection.find(item => item[contentParentKey] === key);
						if (contentParent) {
							const contentTypeCollection = contentParent[contentValuesKey];
							if (contentTypeCollection) {
								const { culture, fallbackCulture } = executionOptions;
								let contentItem = contentTypeCollection.find(item => item.culture === culture);
								if (!contentItem) {
									contentItem = contentTypeCollection.find(item => item.culture === fallbackCulture);
								}
								return (contentItem && contentItem[contentItemKey]) as any;
							}
						}
					}

				}
			}
		}
	}
}